import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        title: i18n.t('scope.text_419'),
        edit: false,
        showDesc: true,
      }),
      {
        field: 'discount',
        title: i18n.t('scope.text_509'),
        formatter: ({ row, cellValue }) => {
          return cellValue * 100 + '%'
        },
      },
      getTimeTableColumn(),
      getTimeTableColumn({
        field: 'updated_at',
        title: i18n.t('common.updatedAt'),
      }),
    ]
  },
}
